import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100000;
`;

const Wrapper = styled.div`
  position: fixed;
  min-width: 200px;
  background: white;
  z-index: 100001;
  border: 1px solid #d8ddec;
  border-radius: 6px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.03);
  padding: 18px 18px 2px 18px;
`;

export const ChatListContextMenuItem = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;

  span {
    margin-left: 12px;
    color: black;
  }
`;

const ChatListContextMenu = ({ isVisible, anchorPoint, hideMenu, children }) =>
  isVisible && anchorPoint ? (
    <Overlay onClick={hideMenu}>
      <Wrapper style={{ top: anchorPoint.y, left: anchorPoint.x }}>{children}</Wrapper>
    </Overlay>
  ) : null;

export default ChatListContextMenu;
